<template>
  <div>
    <div class="sticky-top">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <a
            :href="`${story.canonical_url}/${previewToken}/`"
            target="_blank"
            class="btn btn-outline m-r-10"
          >
            <i class="fa fa-external-link"></i>
            Voir la page
          </a>
          <span v-if="edit">
            <a
              href
              @click.prevent="deleteStory()"
              class="btn btn-warning m-r-10"
            >
              <i class="fa fa-trash"></i>
              Supprimer
            </a>
            <router-link
              :to="{ name: 'story_editor', params: { id: $route.params.id } }"
              class="btn btn-info m-r-10"
            >
              <i class="fa fa-edit"></i>
              Editer le contenu
            </router-link>
            <a href @click.prevent="saveStory()" class="btn btn-primary m-r-10">
              <i class="fa fa-save"></i>
              Enregistrer
            </a>
            <a
              href
              @click.prevent="setEdit(false)"
              class="btn btn-outline m-r-10"
            >
              <i class="fa fa-times"></i>
            </a>
          </span>
          <span v-else>
            <a
              href
              @click.prevent="setEdit(true)"
              class="btn btn-outline m-r-10"
            >
              <i class="fa fa-pencil"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div v-loading="loading">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h2 class="h3" :class="{ 'text-muted': !story.title }">
                      <span
                        v-if="story.rich_title"
                        v-html="story.rich_title"
                      ></span>
                      <span v-else>{{ story.title || "Aucun titre" }}</span>
                      <br />
                      <small>
                        {{ story.slug }}
                        <br />
                        Création le {{ story.created_at | formatDate }}
                        - Dernière mise à jour le
                        {{
                          story.updated_at | formatDate("DD-MM-YYYY à HH:mm")
                        }}
                      </small>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <el-tabs
              v-model="activeTab"
              type="border-card"
              class="m-b-30"
              style="min-height: 270px"
            >
              <el-tab-pane name="attributes" label="Attributs">
                <div class="m-t-10">
                  <div v-if="!edit" class="row">
                    <div class="col-md-6">
                      <dl class="row">
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Auteur(s)
                        </dt>
                        <dd class="col-sm-8">
                          <span
                            v-if="story.authors && story.authors.length > 0"
                          >
                            <router-link
                              v-for="author in story.authors"
                              :key="author.id"
                              :to="{
                                name: 'author',
                                params: { id: author.id },
                              }"
                              >{{ author.screenname }}</router-link
                            >
                          </span>
                        </dd>
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Rubrique
                        </dt>
                        <dd class="col-sm-8">
                          <span
                            v-if="
                              story.story_categories &&
                              story.story_categories.length > 0
                            "
                            >{{ story.story_categories[0].label }}</span
                          >
                        </dd>
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Type
                        </dt>
                        <dd class="col-sm-8">
                          {{ $t(`story.${story.category}`, "-") }}
                        </dd>
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Gabarit
                        </dt>
                        <dd class="col-sm-8">
                          {{ $t(`story.${story.scheme}`) }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-md-6">
                      <dl class="row">
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Statut
                        </dt>
                        <dd class="col-sm-8">
                          {{ $t(`story.${story.status}`) }}
                        </dd>
                        <!-- <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Mode
                        </dt>
                        <dd class="col-sm-8">
                          {{ $t(`story.${story.scope}`) }}
                        </dd> -->
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Publication le
                        </dt>
                        <dd class="col-sm-8">
                          <span v-if="story.published_at">{{
                            story.published_at
                              | formatDate("DD-MM-YYYY à HH:mm")
                          }}</span>
                          <span v-else class="text-muted">Non précisé</span>
                        </dd>
                        <dt class="col-sm-4 m-b-30 text-right text-muted">
                          Accès
                        </dt>
                        <dd class="col-sm-8" v-if="story.scheme == 'STORY'">
                          <span v-if="story.subscriber_only === true"
                            >Réservé aux abonnés</span
                          >
                          <span v-else>Gratuit</span>
                        </dd>
                        <dt class="col-sm-4 text-right text-muted">
                          Commentaires
                        </dt>
                        <dd class="col-sm-8">
                          <span v-if="story.comments_allowed === true"
                            >Autorisés</span
                          >
                          <span v-else>Désactivés</span>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div v-if="edit" class="row">
                    <div class="col-md-12">
                      <el-form
                        label-position="right"
                        size="medium"
                        label-width="120px"
                      >
                        <el-form-item label="Titre">
                          <el-input
                            autosize
                            @input="updateStoryAttribute('title', $event)"
                            :value="story.title"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Extrait">
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 6 }"
                            maxlength="242"
                            show-word-limit
                            @input="updateStoryAttribute('extract', $event)"
                            :value="story.extract"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Chapô">
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 6 }"
                            @input="updateStoryAttribute('headline', $event)"
                            :value="story.headline"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Coulisses">
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 6 }"
                            @input="updateStoryAttribute('backstage', $event)"
                            :value="story.backstage"
                          ></el-input>
                        </el-form-item>
                        <div class="row">
                          <div class="col-md-6">
                            <el-form-item label="Auteurs">
                              <span
                                v-if="story.authors && story.authors.length > 0"
                              >
                                <span
                                  v-for="author in story.authors"
                                  class="btn btn-secondary btn-sm m-l-5"
                                  :key="author.id"
                                >
                                  <i class="fa fa-user"></i>
                                  {{ author.screenname }}
                                  <a
                                    href
                                    @click.prevent="
                                      deleteStoryAuthor(story.id, author.id)
                                    "
                                  >
                                    <i class="fa fa-times"></i>
                                  </a>
                                </span>
                              </span>
                              <story-author-selector
                                class="m-t-10"
                                v-if="addAuthorSelectorVisible"
                                :selectFunction="addStoryAuthor"
                                ref="addAuthorInput"
                              ></story-author-selector>
                              <el-button
                                v-else
                                type="primary"
                                size="mini"
                                class="m-l-10"
                                icon="el-icon-plus"
                                circle
                                @click.prevent="showStoryAuthorSelector"
                              ></el-button>
                            </el-form-item>
                            <el-form-item label="Rubrique princ.">
                              <el-select
                                v-if="story.primary_category"
                                :value="story.primary_category.id"
                                @change="updatePrimaryCategory"
                                filterable
                                placeholder="Liste des rubriques"
                              >
                                <el-option
                                  v-for="item in categoriesTags.filter(
                                    (tag) =>
                                      (story.scheme == 'STORY' &&
                                        tag.scheme == 'CATEGORY') ||
                                      (story.scheme == 'VIDEO' &&
                                        tag.scheme == 'PROGRAM') ||
                                      (story.scheme == 'VIDEO_AUDIO' &&
                                        tag.scheme == 'PROGRAM') ||
                                      (story.scheme == 'AUDIO' &&
                                        tag.scheme == 'PODCAST') ||
                                      tag.id === defaultCategoryId
                                  )"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.id"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="Type">
                              <el-select
                                @change="
                                  updateStoryAttribute('content_type', $event)
                                "
                                :value="story.content_type"
                              >
                                <el-option
                                  v-for="item in constants.STORY_CATEGORIES"
                                  :label="$t(`story.${item}`)"
                                  :key="item"
                                  :value="item"
                                  >{{ $t(`story.${item}`) }}</el-option
                                >
                              </el-select>
                            </el-form-item>
                            <el-form-item label="Gabarit">
                              <el-select
                                @change="updateStoryAttribute('scheme', $event)"
                                :value="story.scheme"
                              >
                                <el-option
                                  v-for="item in constants.STORY_SCHEMES"
                                  :label="$t(`story.${item}`)"
                                  :key="item"
                                  :value="item"
                                  >{{ $t(`story.${item}`) }}</el-option
                                >
                              </el-select>
                            </el-form-item>
                          </div>
                          <div class="col-md-6">
                            <el-form-item label="Statut">
                              <el-select
                                @change="updateStoryAttribute('status', $event)"
                                :value="story.status"
                              >
                                <el-option
                                  v-for="item in constants.STORY_STATUSES"
                                  :label="$t(`story.${item}`)"
                                  :key="item"
                                  :value="item"
                                  >{{ $t(`story.${item}`) }}</el-option
                                >
                              </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="Mode">
                              <el-select
                                @change="updateStoryAttribute('scope', $event)"
                                :value="story.scope"
                              >
                                <el-option
                                  v-for="item in constants.STORY_SCOPES"
                                  :label="$t(`story.${item}`)"
                                  :key="item"
                                  :value="item"
                                  >{{ $t(`story.${item}`) }}</el-option
                                >
                              </el-select>
                            </el-form-item> -->
                            <el-form-item label="Publication">
                              <el-date-picker
                                v-model="story_published_at"
                                @change="updateStoryPublishedAt"
                                type="datetime"
                                format="dd-MM-yyyy HH:mm"
                                placeholder="Choississez un jour"
                              ></el-date-picker>
                            </el-form-item>
                            <el-form-item
                              v-if="story.scheme == 'STORY'"
                              label="Accès"
                            >
                              <el-checkbox
                                @change="updateStorySubscriberOnly"
                                :value="story.subscriber_only"
                                >Réservé aux abonnés</el-checkbox
                              >
                            </el-form-item>
                            <el-form-item label="Commentaires">
                              <el-checkbox
                                @change="updateStoryCommentsAllowed"
                                :value="story.comments_allowed"
                                >Autorisés</el-checkbox
                              >
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane name="related" label="À lire aussi">
                <story-related
                  :edit="edit"
                  :parentInitFunction="init"
                ></story-related>
              </el-tab-pane>
              <el-tab-pane
                name="publicationRules"
                label="Règles de publication"
              >
                <story-publication
                  :edit="edit"
                  :parentInitFunction="init"
                ></story-publication>
              </el-tab-pane>
              <el-tab-pane name="attachments" label="Attributs spéciaux">
                <story-attachments
                  :edit="edit"
                  :parentInitFunction="init"
                ></story-attachments>
              </el-tab-pane>
            </el-tabs>
            <div class="row">
              <div class="col-md-8">
                <el-tabs
                  v-if="
                    story.scheme == 'VIDEO' || story.scheme == 'VIDEO_AUDIO'
                  "
                  type="border-card"
                  class="m-b-30"
                >
                  <el-tab-pane label="Vidéo YouTube">
                    <story-youtube-player
                      :source="videoYoutube.value"
                    ></story-youtube-player>
                    <el-input
                      v-if="edit"
                      v-model="videoYoutube.value"
                      placeholder="URL YouTube"
                    ></el-input>
                  </el-tab-pane>
                </el-tabs>

                <el-tabs
                  v-if="
                    story.scheme == 'VIDEO' || story.scheme == 'VIDEO_AUDIO'
                  "
                  type="border-card"
                  class="m-b-30"
                >
                  <el-tab-pane label="Vidéo PeerTube">
                    <story-peertube-player
                      :source="videoPeertube.value"
                    ></story-peertube-player>
                    <el-input
                      v-if="edit"
                      v-model="videoPeertube.value"
                      placeholder="URL PeerTube"
                    ></el-input>
                  </el-tab-pane>
                </el-tabs>

                <el-tabs
                  v-if="
                    story.scheme == 'AUDIO' || story.scheme == 'VIDEO_AUDIO'
                  "
                  type="border-card"
                  class="m-b-30"
                >
                  <el-tab-pane label="Audio">
                    <story-audio-player
                      :source="audioSource.value"
                    ></story-audio-player>
                    <el-input
                      v-if="edit"
                      v-model="audioSource.value"
                      placeholder="Source URL"
                    ></el-input>
                  </el-tab-pane>
                </el-tabs>

                <el-tabs type="border-card" class="m-b-30">
                  <el-tab-pane label="Article">
                    <div v-if="story.extract">
                      <h3 class="h5">Extrait</h3>
                      <div v-if="story.extract" class="lead">
                        <p class="lead">{{ story.extract }}</p>
                        <hr />
                      </div>
                    </div>
                    <div v-if="story.headline">
                      <h3 class="h5">Chapô</h3>
                      <p class="lead">{{ story.headline }}</p>
                      <hr />
                    </div>
                    <div class="story-content" v-html="story.content"></div>
                    <div v-if="story.backstage">
                      <hr />
                      <h3 class="h5">Coulisses</h3>
                      <p class="lead">{{ story.backstage }}</p>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="col-md-4">
                <el-tabs type="border-card" class="m-b-30">
                  <el-tab-pane label="Illustration">
                    <div>
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="story.cover_image_url"
                        :preview-src-list="[story.cover_image_url]"
                        fit="contain"
                      ></el-image>
                    </div>
                    <div v-if="edit" class="m-b-20">
                      <div class="row">
                        <div class="col-md-6">
                          <el-upload
                            :show-file-list="false"
                            :action="
                              `stories/${$route.params.id}/upload-cover/`
                                | api_url
                            "
                            :http-request="uploadCover"
                          >
                            <el-button size="small" type="primary">
                              <i class="fa fa-upload"></i>
                              Choisir
                            </el-button>
                          </el-upload>
                        </div>
                        <div class="col-md-6 text-right">
                          <router-link
                            v-if="story.cover_image_url"
                            tag="span"
                            class="m-l-10"
                            :to="{
                              name: 'story_thumbnails',
                              params: { id: story.id },
                            }"
                          >
                            <el-button size="small" type="info">
                              <i class="fa fa-crop"></i>
                              Modifier
                            </el-button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <el-form v-if="edit" label-position="top" size="medium">
                      <el-form-item>
                        <el-input
                          placeholder="Crédits photo"
                          @input="
                            updateStoryAttribute('cover_image_credits', $event)
                          "
                          :value="story.cover_image_credits"
                        ></el-input>
                      </el-form-item>
                    </el-form>
                    <p v-else class="text-right">
                      <small>{{ story.cover_image_credits }}</small>
                    </p>
                  </el-tab-pane>
                </el-tabs>
                <el-tabs
                  v-if="
                    (story.story_tags && story.story_tags.length > 0) || edit
                  "
                  type="border-card"
                  class="m-b-30"
                >
                  <el-tab-pane label="Tags">
                    <el-form v-if="edit" label-position="right" size="medium">
                      <el-form-item>
                        <span
                          v-if="story.story_tags && story.story_tags.length > 0"
                        >
                          <span
                            v-for="tag in story.story_tags"
                            class="btn btn-secondary btn-sm m-l-5"
                            :key="tag.id"
                          >
                            <i class="fa fa-tag"></i>
                            {{ tag.label }}
                            <a
                              href
                              @click.prevent="deleteStoryTag(story.id, tag.id)"
                            >
                              <i class="fa fa-times"></i>
                            </a>
                          </span>
                        </span>
                        <story-tag-selector
                          class="m-t-10"
                          v-if="addTagSelectorVisible"
                          :selectFunction="addStoryTag"
                          :createFunction="createStoryTag"
                          autocompletePlaceholder="Rechercher ou créer un tag"
                          selectPlaceholder="Liste des tags"
                          :highlightFirstItem="false"
                          ref="addTagInput"
                          schemes="STORY_TAG"
                        ></story-tag-selector>
                        <el-button
                          v-else
                          type="primary"
                          size="mini"
                          class="m-l-10"
                          icon="el-icon-plus"
                          circle
                          @click.prevent="showStoryTagSelector"
                        ></el-button>
                      </el-form-item>
                    </el-form>
                    <div v-else>
                      <span
                        v-if="story.story_tags && story.story_tags.length > 0"
                      >
                        <span
                          v-for="tag in story.story_tags"
                          class="d-inline-block m-l-5 m-b-5"
                          :key="tag.id"
                        >
                          <router-link
                            :key="tag.id"
                            :to="{ name: 'tag', params: { id: tag.id } }"
                          >
                            <i class="fa fa-tag"></i>
                            {{ tag.label }}
                          </router-link>
                        </span>
                      </span>
                    </div>
                  </el-tab-pane>
                </el-tabs>
                <el-tabs
                  v-if="
                    story.scheme == 'AUDIO' || story.scheme == 'VIDEO_AUDIO'
                  "
                  type="border-card"
                  class="m-b-30"
                >
                  <el-tab-pane label="Illustration du podcast">
                    <div>
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="story.podcast_image_url"
                        :preview-src-list="[story.podcast_image_url]"
                        fit="contain"
                      ></el-image>
                    </div>
                    à
                    <div v-if="edit" class="m-b-20">
                      <div class="row">
                        <div class="col-md-6">
                          <el-upload
                            :show-file-list="false"
                            :action="
                              `stories/${$route.params.id}/upload-podcast-image/`
                                | api_url
                            "
                            :http-request="uploadPodcastImage"
                          >
                            <el-button size="small" type="primary">
                              <i class="fa fa-upload"></i>
                              Choisir
                            </el-button>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <!-- <pre>{{ constants }}</pre> -->
            <!-- <pre>{{ story }}</pre> -->
            <!-- <pre>{{ categoriesTags }}</pre> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters({
    constants: "constants",
    story: "story",
    tag: "tag",
  }),
  components: {},
  data() {
    return {
      activeTab: "attributes",
      loading: false,
      edit: false,
      mask:
        "id,title,rich_title,headline,extract,content,backstage,status,canonical_url,cover_image_url,scheme," +
        "cover_image, cover_image_credits,scope,primary_category{id,label},created_at,updated_at," +
        "content_type,slug,comments_allowed,subscriber_only,published_at,is_published," +
        "authors{id,screenname}," +
        "attachments,attachments_by_keys,attributes," +
        "publication_rules," +
        "story_tags{id,label},contextual_stories{id,title},contextual_carousel{id,title}," +
        "story_categories{id,label}," +
        "related_stories{id,title,thumb_story_list_url,primary_category{label},created_at,published_at}," +
        "podcast_image_url",
      tags: null,
      categoriesTags: [],
      newTag: null,
      addTagSelectorVisible: false,
      addAuthorSelectorVisible: false,
      story_published_at: null,
      videoYoutube: { value: null },
      videoPeertube: { value: null },
      audioSource: { value: null },
      defaultCategoryId: "a88aae57-1f1d-4474-b703-4bd7b7ac93b9",
      previewToken: null,
    };
  },
  watch: {
    $route(to, from) {
      this.edit = JSON.parse(to.query.edit);
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      if (!this.$route.params.id) {
        this.$router.push({ name: "stories" });
      }
      this.loading = true;
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit;
      }
      this.$store.dispatch("getConstants", {
        params: {
          keys:
            "STORY_STATUSES,STORY_SCOPES,STORY_SCHEMES," +
            "STORY_THUMBNAILS_KEYS,STORY_CATEGORIES,STORY_DISPLAY_SECTIONS",
        },
      });
      this.$store
        .dispatch("getStory", {
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask,
          },
        })
        .then(() => {
          if (this.story.attachments_by_keys.video_youtube) {
            this.videoYoutube = Object.assign(
              {},
              this.story.attachments_by_keys.video_youtube
            );
          }
          if (this.story.attachments_by_keys.video_peertube) {
            this.videoPeertube = Object.assign(
              {},
              this.story.attachments_by_keys.video_peertube
            );
          }
          if (this.story.attachments_by_keys.audio) {
            this.audioSource = Object.assign(
              {},
              this.story.attachments_by_keys.audio
            );
          }
          this.tags = JSON.parse(JSON.stringify(this.story.story_tags));
          this.categories_tags = JSON.parse(
            JSON.stringify(this.story.story_tags)
          );
          this.story_published_at = JSON.parse(
            JSON.stringify(this.story.published_at)
          );
          this.loading = false;

          _this.categoriesTags = [];
          this.axios
            .get("/tags/", {
              params: {
                status: "ENABLED",
                schemes: "CATEGORY,PROGRAM,PODCAST",
                per_page: 10000,
              },
              headers: { "x-fields": "id,label,scheme" },
            })
            .then((response) => {
              response.data.results.map(function (value, key) {
                _this.categoriesTags.push({
                  label: value.label,
                  id: value.id,
                  scheme: value.scheme,
                });
              });
            });
          this.updateStoryAttribute(
            "cover_image_url",
            this.story.cover_image_url + "?d=" + new Date()
          );
          this.getPreviewToken();
        });
    },
    isPublishable() {
      if (!this.story.title.length) {
        this.$message({
          type: "error",
          message:
            "Vous devez définir un titre pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (this.story.primary_category.id === null) {
        this.$message({
          type: "error",
          message:
            "Vous devez sélectionner une rubrique pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (this.story.authors.length === 0) {
        this.$message({
          type: "error",
          message:
            "Vous devez associer au moins un auteur pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (!this.story.cover_image) {
        this.$message({
          type: "error",
          message:
            "Vous devez ajouter une illustration pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (this.story.content.length === 0) {
        this.$message({
          type: "error",
          message:
            "Vous devez ajouter un corps de texte pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (
        (this.story.scheme === "VIDEO" ||
          this.story.scheme === "VIDEO_AUDIO") &&
        !this.videoYoutube.value
      ) {
        this.$message({
          type: "error",
          message:
            "Vous devez ajouter le lien d'une vidéo pour pouvoir publier un contenu.",
        });
        return false;
      }
      if (
        (this.story.scheme === "AUDIO" ||
          this.story.scheme === "VIDEO_AUDIO") &&
        !this.audioSource.value
      ) {
        this.$message({
          type: "error",
          message:
            "Vous devez ajouter le lien d'un podcast pour pouvoir publier un contenu.",
        });
        return false;
      }
      return true;
    },
    saveStory(silent) {
      if (this.story.status == "PUBLISHED" && this.isPublishable() === false) {
        this.updateStoryAttribute("status", "DISABLED");
        silent = true;
      }
      this.loading = true;
      let attachmentYoutubeKeyFound = false;
      let attachmentPeertubeKeyFound = false;
      let attachmentAudioKeyFound = false;
      let attachments = JSON.parse(JSON.stringify(this.story.attachments));
      if (this.story.scheme == "VIDEO" || this.story.scheme == "VIDEO_AUDIO") {
        attachments.forEach((v, k) => {
          if (v.key === "video_youtube") {
            attachmentYoutubeKeyFound = true;
            v.value = this.videoYoutube.value;
          }
          if (v.key === "video_peertube") {
            attachmentPeertubeKeyFound = true;
            v.value = this.videoPeertube.value;
          }
        });
        if (attachmentYoutubeKeyFound === false) {
          attachments.push({
            id: null,
            story_id: this.$route.params.id,
            key: "video_youtube",
            value: this.videoYoutube.value,
          });
        }
        if (attachmentPeertubeKeyFound === false) {
          attachments.push({
            id: null,
            story_id: this.$route.params.id,
            key: "video_peertube",
            value: this.videoPeertube.value,
          });
        }
      }
      if (this.story.scheme == "AUDIO" || this.story.scheme == "VIDEO_AUDIO") {
        attachments.forEach((v, k) => {
          if (v.key === "audio") {
            attachmentAudioKeyFound = true;
            v.value = this.audioSource.value;
          }
        });
        if (attachmentAudioKeyFound === false) {
          attachments.push({
            id: null,
            story_id: this.$route.params.id,
            key: "audio",
            value: this.audioSource.value,
          });
        }
      }

      this.updateStoryAttribute("attachments", attachments);
      return this.$store
        .dispatch("saveStory", {
          headers: {
            "X-Fields": this.mask,
            "X-UpdateKeys":
              "title,extract,status,content_type,scheme,scope,category,primary_category,publication_rules," +
              "headline,backstage,comments_allowed,subscriber_only,cover_image_credits,published_at,attachments",
          },
        })
        .then(() => {
          this.loading = false;
          if (!silent) {
            this.$message({
              type: "success",
              message: "Enregistrement effectué avec succès",
            });
          }
          this.init();
        });
    },
    deleteStory() {
      this.$confirm("Ceci effacera l’article. Continuer ?", "Warning", {
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("deleteStory", {
              id: this.$route.params.id,
              headers: {
                "X-Fields": this.mask,
              },
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Article supprimé",
              });
              this.$router.replace({
                name: "stories",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée",
          });
        });
    },
    showStoryTagSelector() {
      this.addTagSelectorVisible = true;
      this.$nextTick((_) => {
        this.$refs.addTagInput.$refs.autocomplete.$refs.input.focus();
      });
    },
    addStoryTag(tag) {
      this.$store
        .dispatch("addStoryTag", {
          story_id: this.$route.params.id,
          tag_id: tag.id,
          headers: {
            "X-Fields": this.mask,
          },
        })
        .then(() => {
          this.$refs.addTagInput.clearInput();
          this.$message({
            type: "success",
            message: "Tag ajouté",
          });
        });
    },
    createStoryTag(label) {
      if (label) {
        this.$confirm(
          `Vous allez créer un nouveau Tag "${label}". Si le Tag existe déjà, il sera simplement associé à l’article. Continuer ?`,
          "Warning",
          {
            confirmButtonText: "Créer ou associer le Tag",
            cancelButtonText: "Annuler",
            type: "warning",
          }
        )
          .then(() => {
            this.$store
              .dispatch("createTag", {
                status: "ENABLED",
                label: label,
                scheme: "STORY_TAG",
              })
              .then(() => {
                this.addStoryTag({ id: this.tag.id });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Création du Tag annulée",
            });
          });
      }
    },
    deleteStoryTag(storyId, tagId) {
      this.$confirm("Ceci effacera le tag. Continuer ?", "Warning", {
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("deleteStoryTag", {
              story_id: storyId,
              tag_id: tagId,
              headers: {
                "X-Fields": this.mask,
              },
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Tag supprimé",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée",
          });
        });
    },
    showStoryAuthorSelector() {
      this.addAuthorSelectorVisible = true;
      this.$nextTick((_) => {
        this.$refs.addAuthorInput.$refs.autocomplete.$refs.input.focus();
      });
    },
    deleteStoryAuthor(storyId, authorId) {
      this.$confirm("Supprimer cet auteur. Continuer ?", "Warning", {
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("deleteStoryAuthor", {
              story_id: storyId,
              author_id: authorId,
              headers: {
                "X-Fields": this.mask,
              },
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Auteur supprimé",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée",
          });
        });
    },
    addStoryAuthor(author) {
      this.$store
        .dispatch("addStoryAuthor", {
          story_id: this.$route.params.id,
          author_id: author.id,
          headers: {
            "X-Fields": this.mask,
          },
        })
        .then(() => {
          this.$refs.addAuthorInput.clearInput();
          this.$message({
            type: "success",
            message: "Auteur ajouté",
          });
        });
    },
    updateStoryCommentsAllowed(value) {
      this.updateStoryAttribute("comments_allowed", value);
    },
    updateStorySubscriberOnly(value) {
      this.updateStoryAttribute("subscriber_only", value);
    },
    updateStoryPublishedAt(value) {
      this.updateStoryAttribute(
        "published_at",
        new Date(value.getTime() - value.getTimezoneOffset() * 60000)
          .toISOString()
          .replace("Z", "")
      );
    },
    updateStoryAttribute(key, value) {
      let data = {
        [key]: value,
      };
      this.$store.commit("UPDATE_STORY_VALUE", data);
    },
    updateStoryAttachmentValue(key, value, index) {
      let attachments = JSON.parse(JSON.stringify(this.story.attachments));
      attachments[index][key] = value;
      this.$store.commit("UPDATE_STORY_VALUE", {
        attachments: attachments,
      });
    },
    updatePrimaryCategory(value) {
      this.categoriesTags.forEach((v) => {
        if (v.id === value) {
          this.updateStoryAttribute("primary_category", v);
        }
      });
    },
    setEdit(edit) {
      if (edit === false) {
        this.addTagSelectorVisible = false;
        this.addAuthorSelectorVisible = false;
      }
      this.$router.push({
        name: "story",
        params: { id: this.$route.params.id },
        query: { edit: edit },
      });
    },
    uploadCover(option) {
      const formData = new FormData();
      formData.append("image", option.file);
      this.$store
        .dispatch("uploadStoryCover", {
          formEncodedData: formData,
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask,
          },
        })
        .then(() => {
          this.updateStoryAttribute(
            "cover_image_url",
            this.story.cover_image_url + "?d=" + new Date()
          );
        });
    },
    uploadPodcastImage(option) {
      const formData = new FormData();
      formData.append("image", option.file);
      this.$store
        .dispatch("uploadStoryPodcastImage", {
          formEncodedData: formData,
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask,
          },
        })
        .then(() => {
          this.updateStoryAttribute(
            "podcast_image_url",
            this.story.podcast_image_url + "?d=" + new Date()
          );
        });
    },
    getPreviewToken() {
      return this.axios.post("/auth/forge-token/").then((response) => {
        this.previewToken = response.data.results.token;
      });
    },
  },
};
</script>
<style>
.story-content h1 {
  font-size: 26px !important;
}

.story-content h2 {
  font-size: 24px !important;
}

.story-content h3 {
  font-size: 20px !important;
}

.story-content h4 {
  font-size: 18px !important;
}

.input-new-tag .el-input__inner {
  width: 120px;
}

.input-new-tag {
  width: 120px !important;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
